export default "__VITE_ASSET__CJgwDCLj__"